import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { styled } from "@mui/material/styles";
import * as React from "react";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
 "& .MuiDialogContent-root": {
  padding: theme.spacing(2),
  minWidth: "670px",
 },
 "& .MuiDialogActions-root": {
  padding: theme.spacing(1),
 },
}));
const RegenerateButton = styled(Button)(({ theme }) => ({
 color: "black",
 textTransform: "none",
 border: "solid 1px #6019F9",
 borderRadius: "20px",
 backgroundColor: "white",
 padding: "0px !important",
 "&:hover": {
  backgroundColor: "white",
 },
}));

export default function ApproverConfimPopup(props) {
 const handleClose = () => {
  props.handleMailerStatus();
  props.setOpenConfirmPopup(false);
 };
 const handleCloseFalse = () => {
  props.setOpenConfirmPopup(false);
 };
 return (
  <React.Fragment>
   <BootstrapDialog open={props.openConfirmPopup} onClose={handleClose}>
    <DialogContent>
     <Typography
      sx={{
       fontSize: "16px",
       fontFamily: "Graphik-Regular",
       textAlign: "center",
       marginTop: "20px",
       fontWeight: "600",
      }}
     >
      {props.buttonText == "Approve"
       ? "Are you sure you want to approve this content?"
       : "Are you sure you want to discard this content?"}
     </Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: "center", marginBottom: "10px" }}>
     <RegenerateButton
      onClick={() => {
       handleClose();
      }}
     >
      Yes
     </RegenerateButton>
     <RegenerateButton
      onClick={() => {
       handleCloseFalse();
      }}
     >
      No
     </RegenerateButton>
    </DialogActions>
   </BootstrapDialog>
  </React.Fragment>
 );
}
